import React from 'react'
import './style.scss'

function SubspendMessage(props) {
    return (
        <>
        {
            props.statusType == '2' ?
            <div className='mt-4 suspend'>
                <h6 className='text-danger'><i class="mdi mdi-alert" style={{ color: 'red', fontSize: '20px' }}></i>&nbsp; Missing Subscription Details</h6>
                <p className='text-gray'>Your account is now in a semi-suspended state during which your account functionality will be limited. To resume services, please make the required payment.
                    Due to semi-suspended you don't have access to this screen. In case of any queries, please feel free to reach out to our support team at  support@infomo.com</p>
            </div> : props.statusType == '0' ?
            <>
            <div className='mt-4 suspend'>
                <h6 className='text-danger'><i class="mdi mdi-alert" style={{ color: 'red', fontSize: '20px' }}></i>&nbsp; Missing Subscription Details</h6>
                <p className='text-gray'>Your account is in suspended state. Hence you currently do not have access.</p>
            </div>
            </> : ''

        }
        </>
    )
}

export default SubspendMessage
